import React from "react";

/**
 * Clean stroke-style WhatsApp icon (Tabler-style).
 * Uses currentColor so it can render in gold/cream cleanly.
 */
export const WhatsAppIcon = ({
  className = "",
  strokeWidth = 1.5,
  ...rest
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...rest}
  >
    <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
    <path d="M9 10a.5.5 0 1 0 1 0V9a.5.5 0 1 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 1 0 0-1h-1a.5.5 0 1 0 0 1" />
  </svg>
);

export default WhatsAppIcon;
